import React from 'react';
import SelectionStatus from 'portfolio/components/SelectionStatus';

import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { useWidgetMessagesAdornedWithSymbologyWarning } from 'widgets/WidgetSymbologyWarning';
import { StreamMessage } from 'utils/messages/StreamMessage';
import {
    createGridChartViewToggleButtons,
    GridChartView,
} from 'utils/components/ViewToggleButtons/ViewToggleButtons.tsx';
import { useVolumeCurveConfigSlice } from 'widgets/volumeCurve/store/configuration/configSlice.ts';
import { VolumeCurveTimeLabel } from './time-label/VolumeCurveTimeLabel.tsx';
import VolumeCurveSettings from 'widgets/volumeCurve/components/settings/VolumeCurveSettings.tsx';
import {
    GridApi,
    GridExportButton,
} from '@instinet-analytics/semantic-ui-components';
import { VolumeCurveData } from 'widgets/volumeCurve/data/volumeCurveData.ts';
import VolumeCurveHelp from 'widgets/volumeCurve/components/help/VolumeCurveHelp.tsx';

interface VolumeCurveHeaderProps {
    data: VolumeCurveData;
    gridApi?: GridApi;
    messages: StreamMessage[];
}

export default function VolumeCurveHeader(props: VolumeCurveHeaderProps) {
    const { data, messages: messagesProps, gridApi } = props;
    const { config, dispatchConfigChanged } = useVolumeCurveConfigSlice();

    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const widgetMessages = useWidgetMessagesAdornedWithSymbologyWarning();
    const messages = [...messagesProps, ...widgetMessages];

    const onViewChanged = (view: GridChartView) => {
        dispatchConfigChanged({ view });
    };

    return (
        <WidgetToolbarShowHidePanel mustShow={!hasValidSelection}>
            <div className="VolumeCurveHeader panel-header">
                {!hasValidSelection && (
                    <div className="toolbar">
                        <SelectionStatus
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                            widgetName="Volume Curve Widget"
                        />
                    </div>
                )}
                {hasValidSelection && (
                    <>
                        <div style={{ display: 'flex' }}>
                            <VolumeCurveTimeLabel data={data} />
                            <VolumeCurveHelp />
                        </div>

                        <WidgetToolbar
                            collapsibleItems={createGridChartViewToggleButtons(
                                config.view,
                                onViewChanged
                            )}
                            showEditLayout={hasValidSelection}
                            messages={messages}
                            hideMessages={!hasValidSelection}
                            settingsBody={<VolumeCurveSettings />}
                            settingsHeader={'Volume Curve Settings'}
                            settingsClassName={'VolumeCurveSettings'}
                            settingsTriggerText={'Volume Curve Settings'}
                            fixedItems={
                                gridApi && config.view === 'grid' ? (
                                    <GridExportButton
                                        csvFileName={'VolumeCurve'}
                                        gridApi={gridApi}
                                    />
                                ) : undefined
                            }
                        />
                    </>
                )}
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
